import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import close from "../../assets/icons/close.svg";
import "../../assets/css/Modal.css";
import { reactSelectStyles } from "../../Utils/selectBoxStyle";
import { useFocusTrap } from "../../Utils/TabIndexingFocus";
import { getData, Postdata } from "../../API/GlobalApi";
import Notifier from "../../Utils/notify";
import { CreatePIN } from "./CreatePin";
import Session from "../../Utils/Sessions";

export const TransferReconcile = ({ isOpen, onClose, selectedTxnStats, getTransactions, currentPage, currentFilters, sanitizeFilters, setFilterQueryString }) => {

    // console.log("selectedTxnStats======", selectedTxnStats)
    const [bankOptions, setBankOptions] = useState([]);
    const [defaultBank, setDefaultBank] = useState(null);

    const [openPinGenerateModal, setOpenPinGenerateModal] = useState(false)
    const ONLINE_TXN_TYPES = [
        "Credit Card",
        "Debit Card",
        "Wallet",
        "EMI",
        "Card",
        "MW",
    ]

    const [statusChoices, setStatusChoices] = useState([]);
    const getStatusOfAccounts = async () => {
        try {
            const response = await getData("finance/reconcile-status/");

            if (response?.status_choices) {
                setStatusChoices(response.status_choices);
            }
        } catch (error) {
            console.error("Error fetching reconcile status:", error);
        }
    };

    useEffect(() => {
        getStatusOfAccounts()
    }, [])
    const getInstitutionsBankAccounts = async () => {
        try {
            const res = await getData("finance/institution-bank-accounts/");
            if (Array.isArray(res)) {
                const options = res.map((acc) => ({
                    value: acc.id,
                    label: `A/C: ${acc.account_number} - ${acc.account_holder_name} - ${acc.bank_name}`,
                    is_default: acc.is_default,
                    default_online_account: acc.default_online_account,
                }));
                setBankOptions(options);
                let defaultAcc = null;
                if (ONLINE_TXN_TYPES.includes(selectedTxnStats?.instrument)) {
                    defaultAcc = options.find((acc) => acc.default_online_account);
                }
                if (!defaultAcc) {
                    defaultAcc = options.find((acc) => acc.is_default);
                }

                if (defaultAcc) setDefaultBank(defaultAcc);
            }
        } catch (error) {
            console.error("Error fetching bank accounts:", error);
        }
    };

    useEffect(() => {
        getInstitutionsBankAccounts();
    }, [selectedTxnStats]);


    const [formData, setFormData] = useState({
        bankAccount: null,
        status: "",    // ✅ universal status
        amount: selectedTxnStats?.amount,    // ✅ universal reconciled amount
    });

    useEffect(() => {
        if (selectedTxnStats?.amount) {
            setFormData((prev) => ({
                ...prev,
                amount: selectedTxnStats.amount, // update amount when txn changes
            }));
        }
    }, [selectedTxnStats]);


    const [selectedRows, setSelectedRows] = useState([]);
    const [showPinInput, setShowPinInput] = useState(false);
    const [pin, setPin] = useState("");

    const trapRef = useFocusTrap(isOpen);


    const txnType = selectedTxnStats?.instrument || "";




    const handleChange = (type, key, value) => {
        setFormData((prev) => {
            if (type === "cheque" || type === "dd") {
                return {
                    ...prev,
                    [type]: {
                        ...prev[type],
                        [key]: {
                            ...(prev[type][key] || {}),
                            ...value,
                        },
                    },
                };
            }
            return {
                ...prev,
                [type]: {
                    ...prev[type],
                    [key]: value,
                },
            };
        });
    };


    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const items = getPaymentItems();
            setSelectedRows(items.map((item) => getItemKey(item)));
        } else {
            setSelectedRows([]);
        }
    };

    const handleRowSelect = (key) => {
        setSelectedRows((prev) =>
            prev.includes(key) ? prev.filter((id) => id !== key) : [...prev, key]
        );
    };

    const getPaymentItems = () => {
        const directTypes = [
            "Cash",
            "Card",
            "Credit Card",
            "Debit Card",
            "Wallet",
            "EMI",
            "MW",
            "Net Banking",
            "UPI",
            "Other",
            "NEFT",
            "IMPS",
            "RTGS",
            "UPIQR",
            "UPI in Bank",
            "Rupay",
            "Visa",
            "MasterCard"
        ];

        if (directTypes.includes(txnType)) {
            return [{ ...selectedTxnStats }];
        }

        if (txnType === "Cheque") {
            return selectedTxnStats.transaction_details?.cheque_details
                ? [selectedTxnStats.transaction_details.cheque_details]
                : [];
        }

        if (txnType === "Demand Draft") {
            return selectedTxnStats.transaction_details?.dd_details
                ? [selectedTxnStats.transaction_details.dd_details]
                : [];
        }

        return [];
    };


    const getItemKey = (item) =>
        item.dd_number || item.cheque_number || selectedTxnStats.transaction_id;


    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleFinalSubmit = async () => {
        if (pin.length !== 4) {
            Notifier.error("Please enter a valid 4-digit PIN");
            return;
        }
        setIsSubmitting(true);

        let payload = {
            deposit_id: selectedTxnStats?.id,
            status: formData.status || "Pending",
            amount: selectedTxnStats?.amount || 0,
            security_pin: pin
        };

        try {
            const res = await Postdata("finance/balance-deposit/reconcile/", payload);

            if (!res?.error) {
                Notifier.success(res?.message)
                // setIsSearchModeFeeRemitance(false); // 🔓 unlock effect
                await getTransactions(currentPage, currentFilters); // 🔄 refresh
                handleResetAndClose();
            } else {
                Notifier.error(res?.error);
            }
        } catch (err) {
            console.error("Reconcile API Error:", err);
            Notifier.error(err);
        } finally {
            setIsSubmitting(false);   // ⭐ Stop loader
        }


    };




    const handleResetAndClose = () => {
        setFormData({
            bankAccount: null,
            cash: { amount: "" },
            cheque: {},
            dd: {},
        });
        setSelectedRows([]);
        setShowPinInput(false);
        setPin("");
        onClose(); // close modal
    };
    const pinInputRef = useRef(null);

    const paymentItems = getPaymentItems();
    // Focus on PIN input when it's rendered
    useEffect(() => {
        if (showPinInput && pinInputRef.current) {
            pinInputRef.current.focus();
        }
    }, [showPinInput]);



    const handleGeneratePin = () => {
        setOpenPinGenerateModal(true)
    }

    if (!isOpen) return null;
    return (
        <div className="modal-overlay">
            <div
                className="modal-content"
                style={{
                    position: "relative",
                    width: "50%",
                    minHeight: "500px",
                    display: "flex",
                    flexDirection: "column",
                }}
                ref={trapRef}
            >
                {/* Header */}
                <div
                    className="modal-header-content"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                    }}
                >
                    <h2 className="text-primary">
                        Reconciliation of {txnType || "Payment"} Deposit
                    </h2>
                    <button className="close-btn" onClick={handleResetAndClose}>
                        <img src={close} alt="close" />
                    </button>
                </div>

                {/* Body */}
                <div
                    className="modal-body"
                    style={{ flex: 1, overflowY: "auto", paddingBottom: "20px" }}
                >
                    {/* Bank Selection */}
                    <div className="row">
                        <div className="col-md-4">
                            <label className="form-labell">
                                Selected Bank Account<span className="astrisk">*</span>
                            </label>
                        </div>
                        <div className="col-md-6">
                            <Select
                                options={bankOptions}
                                value={defaultBank}
                                isDisabled
                                onChange={(selected) =>
                                    setFormData((prev) => ({ ...prev, bankAccount: selected }))
                                }
                                placeholder="Choose Bank Account..."
                                className="react-select-container"
                                classNamePrefix="react-select"
                                styles={{
                                    ...reactSelectStyles,
                                    menuPortal: (base) => ({ ...base, zIndex: 99999999 }),
                                }}
                                menuPortalTarget={document.body}
                                tabSelectsValue={true}
                            />
                        </div>
                    </div>


                    {/* Cash Amount */}
                    {txnType === "Cash" && (
                        <>
                            <div className="row mt-3">
                                <div className="col-md-4">
                                    <label className="form-labell">
                                        Deposited Amount<span className="astrisk">*</span>
                                    </label>
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="number"
                                        className="form-control fm-modal"
                                        value={selectedTxnStats.amount}
                                        readOnly
                                        style={{ width: "100%", marginTop: "10px" }}
                                    />
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-md-4">
                                    <label className="form-labell">
                                        Reconciled Amount<span className="astrisk">*</span>
                                    </label>
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="number"
                                        className="form-control fm-modal"
                                        // placeholder="12000"
                                        value={formData.amount}
                                        onChange={(e) =>
                                            setFormData((prev) => ({ ...prev, amount: e.target.value }))
                                        }
                                        style={{ width: "100%", marginTop: "10px" }}
                                    />
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-4">
                                    <label className="form-labell">Status<span className="astrisk">*</span></label>
                                </div>
                                <div className="col-md-6">
                                    <Select
                                        options={statusChoices
                                            .filter((status) => !(txnType === "Cash" && status === "Re-Present"))
                                            .map((status) => ({
                                                value: status,
                                                label: status,
                                            }))}
                                        value={
                                            formData.status
                                                ? { value: formData.status, label: formData.status }
                                                : null
                                        }
                                        onChange={(selected) =>
                                            setFormData((prev) => ({ ...prev, status: selected.value }))
                                        }
                                        menuPortalTarget={document.body}
                                        styles={{
                                            ...reactSelectStyles,
                                            menuPortal: (base) => ({ ...base, zIndex: 99999999 }) // 👈 keep on top
                                        }}
                                        // menuPlacement="auto"

                                        menuPosition="fixed"
                                    />
                                </div>
                            </div>

                        </>
                    )}
                    {/*   */}

                    {/* Cheque / DD List View */}
                    {txnType !== "Cash" && paymentItems.length > 0 && (
                        <div style={{ marginTop: "40px" }}>
                            <div className="payment-list-transactions">
                                {paymentItems.map((item, idx) => {
                                    const key = getItemKey(item);

                                    return (
                                        <div
                                            key={idx}
                                            className="payment-card shadow-sm p-4 mb-3 rounded border"
                                        >
                                            <div className="row">
                                                {selectedTxnStats.instrument === "Cheque" && (<div className="col-md-6">
                                                    <p className="mb-1">
                                                        <strong>Cheque Number:</strong> {item.dd_number || item.cheque_number || "-"}
                                                    </p>
                                                </div>)}
                                                {selectedTxnStats.instrument === "Cheque" && (<div className="col-md-6">
                                                    <p className="mb-1">
                                                        <strong>Bank</strong> {item.bank_name}
                                                    </p>
                                                </div>)}
                                                {selectedTxnStats.instrument === "Demand Draft" && (<div className="col-md-6">
                                                    <p className="mb-1">
                                                        <strong>Issuing Bank</strong> {item.issuing_bank}
                                                    </p>
                                                </div>)}
                                                {selectedTxnStats.instrument === "Demand Draft" && (<div className="col-md-6">
                                                    <p className="mb-1">
                                                        <strong>Issuing Branch</strong> {item.issuing_branch}
                                                    </p>
                                                </div>)}

                                                {selectedTxnStats.instrument === "Cheque" &&
                                                    (<div className="col-md-6">
                                                        <p className="mb-1">
                                                            <strong>Cheque Date:</strong> {item.cheque_date}
                                                        </p>
                                                    </div>)}
                                                {selectedTxnStats.instrument === "Cheque" &&
                                                    (<div className="col-md-6">
                                                        <p className="mb-1">
                                                            <strong>Deposited Date:</strong>  2025-08-25
                                                        </p>
                                                    </div>)}
                                                {selectedTxnStats.instrument === "Demand Draft" &&
                                                    (<div className="col-md-6">
                                                        <p className="mb-1">
                                                            <strong>Issuing Date:</strong> {item.issuing_date}
                                                        </p>
                                                    </div>)}
                                                <div className="col-md-6">
                                                    <p className="mb-1">
                                                        <strong>Student:</strong> {selectedTxnStats.transfered_from.name}
                                                    </p>
                                                </div>
                                                <div className="col-md-6">
                                                    <p className="mb-1">
                                                        <strong>Amount:</strong> ₹{selectedTxnStats?.amount?.toFixed(2)}
                                                    </p>
                                                </div>


                                            </div>

                                            <div className="row">
                                                {/* Reconciled Amount Input */}
                                                <div className="col-md-6 mt-2">
                                                    <label className="form-label">
                                                        Reconciled Amount<span className="astrisk">*</span>
                                                    </label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Enter Reconciled Amount"
                                                        value={formData.amount}
                                                        style={{ height: '46px' }}
                                                        onChange={(e) =>
                                                            setFormData((prev) => ({ ...prev, amount: e.target.value }))
                                                        }
                                                    />

                                                </div>


                                                <div className="col-md-6 mt-2">
                                                    <label className="form-label">Status<span className="astrisk">*</span></label>
                                                    <Select
                                                        options={statusChoices
                                                            .filter((status) =>
                                                                selectedTxnStats.instrument === "Cheque"
                                                                    ? true // ✅ allow all
                                                                    : status !== "Re-Present" // ❌ hide "Re-Present"
                                                            )
                                                            .map((status) => ({
                                                                value: status,
                                                                label: status,
                                                            }))}
                                                        value={
                                                            formData.status
                                                                ? { value: formData.status, label: formData.status }
                                                                : null
                                                        }
                                                        onChange={(selected) =>
                                                            setFormData((prev) => ({ ...prev, status: selected.value }))
                                                        }
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            ...reactSelectStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 99999999 }) // 👈 keep on top
                                                        }}
                                                        menuPosition="fixed"
                                                    />

                                                </div>
                                            </div>

                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}


                </div>

                {/* Footer */}
                <div
                    className="modal-footer"
                    style={{
                        position: "sticky",
                        bottom: 0,
                        background: "#fff",
                        padding: "10px 20px",
                        textAlign: "right",
                        borderTop: "1px solid #eee",
                    }}
                >
                    {!showPinInput ? (
                        <button
                            className="add-btn"
                            style={{ padding: "10px 20px" }}
                            onClick={() => setShowPinInput(true)}
                        >
                            Reconcile
                        </button>


                    ) : (
                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>

                            <input
                                type="password"
                                ref={pinInputRef}
                                className="form-control"
                                maxLength={4}
                                placeholder="Enter 4-digit PIN"
                                value={pin}
                                onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} // allow only digits
                                style={{
                                    width: "150px",
                                    padding: "8px 10px",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    border: "1px solid #ccc",
                                    borderRadius: "6px",
                                    outline: "none",
                                    boxSizing: "border-box",
                                }}
                            />
                            {/* 
                            {!Session.get("security_pin") && (
                                <button className="add-btn" onClick={handleGeneratePin}>
                                    Create PIN
                                </button>
                            )} */}


                            <button
                                className="add-btn"

                                onClick={handleFinalSubmit}
                                disabled={pin.length !== 4}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    cursor: pin.length !== 4 ? 'not-allowed' : 'pointer',
                                    backgroundColor: pin.length !== 4 ? '#d3d3d3' : '#7F56DA',
                                }}
                            >
                                {isSubmitting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status"></span>

                                    </>
                                ) : (
                                    "Submit"
                                )}
                            </button>
                        </div>
                    )}


                </div>
            </div>
            <CreatePIN isOpen={openPinGenerateModal} onClose={() => setOpenPinGenerateModal(false)} pin={pin} setPin={setPin} />
        </div>
    );
};
